import React from 'react';
import { ArrowRight, MapPin, Mail, Phone } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-[#fafafa] flex justify-center px-4 pb-4">
      <div className="relative w-full max-w-[1440px] bg-zinc-950/95 backdrop-blur-2xl text-white rounded-sm shadow-[0_30px_60px_rgba(0,0,0,0.4)] pt-24 pb-12 px-8 md:px-16 overflow-hidden border border-white/5">
        
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-30 mix-blend-soft-light"
          style={{ backgroundImage: 'url("https://89c7958b302f88270774a4221a06006e.cdn.bubble.io/f1768757672669x486957988311456800/2.png?_gl=1*1t33vr0*_gcl_au*OTYxMjAzODg4LjE3NjUzMTUwMDg.*_ga*Njg0NDczNjkxLjE3NjUzMTUwMDg.*_ga_BFPVR2DEE2*czE3Njg3NTc1MzQkbzQ2JGcxJHQxNzY4NzU3NjMwJGozMiRsMCRoMA..")' }}
        />
        
        <div className="absolute inset-0 bg-gradient-to-b from-zinc-950/90 via-zinc-950/40 to-zinc-950 z-0" />

        {/* Animated background element */}
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-[#D4AF37]/5 blur-[120px] rounded-full pointer-events-none" />

        <div className="relative z-10">
          <div className="max-w-4xl mb-32">
            {/* Level 1 Section Pre-header */}
            <span className="text-[#D4AF37] text-[11px] font-black uppercase tracking-[0.3em] mb-10 block drop-shadow-sm">Final Mandate</span>
            
            <h2 className="text-4xl md:text-6xl font-bold mb-10 tracking-tighter leading-[1.1]">
              If Your Mine Has Real Value, <br />
              <span className="text-zinc-500">It Should Be Seen That Way.</span>
            </h2>

            <div className="space-y-6 max-w-2xl mb-12">
              <p className="text-zinc-300 text-lg leading-relaxed">
                African mining assets deserve better than informal presentation and underpriced deals. Liberta Uhuru exists to ensure serious operations are treated seriously — by investors, banks, and global buyers.
              </p>
              <p className="text-white text-lg font-medium border-l-2 border-[#D4AF37]/50 pl-6 backdrop-blur-sm bg-white/5 py-2 inline-block pr-8 rounded-r-sm">
                If you’re ready to move from undervalued to investable, we should talk.
              </p>
            </div>

            {/* Level 2 functional label - Glass Button */}
            <a 
              href="https://wa.me/27839287731"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center sm:justify-start gap-3 md:gap-4 bg-white/95 backdrop-blur-md text-zinc-950 px-6 md:px-10 py-4 md:py-5 rounded-sm font-bold text-[11px] md:text-[13px] uppercase tracking-[0.1em] md:tracking-widest hover:bg-white transition-all group whitespace-nowrap shadow-2xl border border-white/20 w-full sm:w-auto"
            >
              Book a Strategy Call
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-12 py-16 border-t border-white/5 mb-16">
            <div>
              {/* Level 1 label headers */}
              <h6 className="text-[11px] font-black uppercase tracking-[0.3em] mb-8 text-zinc-500">Firm</h6>
              <ul className="space-y-4 text-sm font-medium text-zinc-400">
                <li><a href="#" className="hover:text-white transition-colors">Our Mandate</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Expertise</a></li>
                <li><a href="#" className="hover:text-white transition-colors">ESG Reporting</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Contact</a></li>
              </ul>
            </div>
            <div>
              <h6 className="text-[11px] font-black uppercase tracking-[0.3em] mb-8 text-zinc-500">Contact</h6>
              <ul className="space-y-6 text-sm font-medium text-zinc-400">
                <li className="flex gap-4">
                  <MapPin className="w-5 h-5 text-[#D4AF37] shrink-0" />
                  <span>106 Palmer Rd, Milton Park, Harare, Zimbabwe</span>
                </li>
                <li className="flex gap-4 group">
                  <Mail className="w-5 h-5 text-[#D4AF37] shrink-0" />
                  <a href="mailto:nicola@libertauhuru.com" className="group-hover:text-white transition-colors">nicola@libertauhuru.com</a>
                </li>
                <li className="flex gap-4 group">
                  <Phone className="w-5 h-5 text-[#D4AF37] shrink-0" />
                  <a href="tel:+27839287731" className="group-hover:text-white transition-colors">+27 83 928 7731</a>
                </li>
              </ul>
            </div>
            <div>
              <h6 className="text-[11px] font-black uppercase tracking-[0.3em] mb-8 text-zinc-500">Insights</h6>
              <ul className="space-y-4 text-sm font-medium text-zinc-400">
                <li><a href="#" className="hover:text-white transition-colors">Investor Readiness</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Market Positioning</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Digital Strategy</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Case Archive</a></li>
              </ul>
            </div>
            <div>
              <h6 className="text-[11px] font-black uppercase tracking-[0.3em] mb-8 text-zinc-500">Legal</h6>
              <ul className="space-y-4 text-sm font-medium text-zinc-400">
                <li><a href="#" className="hover:text-white transition-colors">Terms of Advisory</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Privacy Policy</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Compliance</a></li>
              </ul>
            </div>
          </div>

          {/* Level 1 bottom bar meta */}
          <div className="flex justify-start pt-10 border-t border-white/5 text-[11px] font-black uppercase tracking-[0.3em] text-zinc-600">
            <div className="flex items-center gap-10">
              <span className="opacity-60">© 2025</span>
              <div className="flex items-center gap-4 group cursor-default">
                <img src="/liberta_uhuru.png" alt="Liberta Uhuru Logo" className="w-6 h-6 object-contain group-hover:shadow-[0_0_15px_rgba(212,175,55,0.4)] transition-shadow" />
                <span className="text-[#D4AF37] font-black tracking-[0.4em] leading-none group-hover:opacity-80 transition-opacity">Liberta Uhuru</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;